import { enhanceTrackerWithFullstory } from 'data-ops-fullstory';
import { createTracker } from 'usage-tracker';
export const StandaloneTracker = enhanceTrackerWithFullstory(createTracker({
  standalone: true,
  onError: err => {
    console.error(err);
  }
}));